import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NPDAY_65: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NPDAY_65,
  },
  {
    pageId: PageId.CHAT_UPSELL_NPDAY_65,
  },
  {
    pageId: PageId.UPSELL_NPDAY_65,
  },
  {
    pageId: PageId.DOWNLOAD_NPDAY_65,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
